/* DG Emily — interacciones del tema */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var drawer = function () { return document.getElementById('CartDrawer'); };

  /* ---------- Cajón del carrito ---------- */
  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = theme.routes.cart; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var close = d.querySelector('.drawer__close');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  function renderDrawer(html) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawerInner');
    var current = d.querySelector('#CartDrawerInner');
    if (fresh && current) current.replaceWith(fresh);
    var countEl = doc.querySelector('[data-drawer-count]');
    if (countEl) updateCount(countEl.getAttribute('data-drawer-count'));
  }

  function changeLine(line, quantity) {
    var inner = document.getElementById('CartDrawerInner');
    if (inner) inner.classList.add('is-loading');
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        if (typeof data.item_count !== 'undefined') updateCount(data.item_count);
      })
      .catch(function () { if (inner) inner.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open-cart]');
    if (openBtn && theme.cartType === 'drawer' && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeDrawer(); return; }

    var lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn && lineBtn.closest('#CartDrawer')) {
      e.preventDefault();
      changeLine(Number(lineBtn.dataset.line), Number(lineBtn.dataset.quantity));
      return;
    }

    /* Botones +/- de cantidad genéricos */
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      if (!input) return;
      var min = Number(input.min || 0);
      var next = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyStep));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Buscador del encabezado */
    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      e.preventDefault();
      var panel = document.getElementById('HeaderSearch');
      if (panel) {
        panel.hidden = !panel.hidden;
        searchToggle.setAttribute('aria-expanded', String(!panel.hidden));
        if (!panel.hidden) { var q = panel.querySelector('input'); if (q) q.focus(); }
      }
    }

    /* Miniaturas de producto */
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var main = gallery && gallery.querySelector('[data-main-image]');
      if (main) {
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
      }
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      document.querySelectorAll('details.menu-drawer[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* Cantidad editada a mano dentro del cajón */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (input && input.closest('#CartDrawer')) {
      changeLine(Number(input.dataset.line), Math.max(0, Number(input.value)));
    }

    /* Selector de variante */
    var picker = e.target.closest('[data-variant-select]');
    if (picker) {
      var opt = picker.options[picker.selectedIndex];
      var scope = picker.closest('[data-product]');
      if (!scope || !opt) return;
      var priceEl = scope.querySelector('[data-price]');
      if (priceEl && opt.dataset.priceHtml) priceEl.innerHTML = opt.dataset.priceHtml;
      var btn = scope.querySelector('[data-add-button]');
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        var label = btn.querySelector('[data-add-label]');
        if (label) label.textContent = available ? (theme.cod ? theme.strings.codLabel : theme.strings.addToCart) : theme.strings.soldOut;
      }
      if (opt.dataset.image) {
        var main = scope.querySelector('[data-main-image]');
        if (main) { main.src = opt.dataset.image; main.removeAttribute('srcset'); }
      }
      if (scope.hasAttribute('data-update-url') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
  });

  /* ---------- Pago contra entrega: botones del tema abren Releasit ----------
     Método probado en tienda real: clic en el botón oficial #rsi_buy_now_button.
     Nunca se oculta el contenedor del formulario, solo el botón. */
  var RSI_SEL = [
    '#rsi_buy_now_button', 'button[id*="rsi_buy_now"]',
    '.rsi-integration-container button',
    'button._rsi-buy-now-button', 'a._rsi-buy-now-button',
    '[class*="_rsi-cod-form"] button', '[id*="_rsi-cod-form"] button'
  ].join(',');

  function findRSI() {
    var list = document.querySelectorAll(RSI_SEL);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.hasAttribute('data-cod-buy') || el.closest('._rsi_main_form_element')) continue;
      return el;
    }
    return null;
  }

  /* Marca la oferta «LLEVA N» si el botón trae data-qty. Releasit a veces reinicia la selección: vigilar ~3 s. */
  function selectQty(q) {
    q = parseInt(q, 10); if (!q) return;
    var n = 0, ok = 0, iv = setInterval(function () {
      n++;
      var radios = document.querySelectorAll('input[name="quantity_offer"]'), target = null;
      for (var i = 0; i < radios.length; i++) {
        var lab = radios[i].closest('label'), t = lab ? lab.innerText : '';
        if (new RegExp('LLEVA\\s*' + q + '\\b', 'i').test(t)) { target = radios[i]; break; }
      }
      if (!target && radios.length >= q) target = radios[q - 1];
      if (target) {
        if (!target.checked) { target.click(); ok = 0; } else { ok++; }
        if (ok >= 8 && n >= 14) clearInterval(iv);
      }
      if (n >= 45) clearInterval(iv);
    }, 150);
  }

  function openCOD(btn) {
    var q = btn && btn.getAttribute('data-qty');
    var url = btn && btn.getAttribute('data-product-url');
    var msg = btn && btn.closest('form') ? btn.closest('form').querySelector('[data-form-error]') : null;
    var b = findRSI();
    if (b) { b.click(); selectQty(q); return; }
    /* Fuera de la página de producto (por ejemplo, el inicio) no hay Releasit: ir al producto */
    if (url && url.split('?')[0] !== window.location.pathname) { window.location.href = url; return; }
    if (btn) btn.classList.add('is-loading');
    var tries = 0, iv = setInterval(function () {
      tries++;
      var r = findRSI();
      if (r) { clearInterval(iv); if (btn) btn.classList.remove('is-loading'); r.click(); selectQty(q); }
      else if (tries >= 20) {
        clearInterval(iv);
        if (btn) btn.classList.remove('is-loading');
        if (msg) msg.textContent = theme.strings.codMissing;
      }
    }, 200);
  }

  document.addEventListener('click', function (e) {
    var codBtn = e.target.closest('[data-cod-buy]');
    if (!codBtn) return;
    e.preventDefault();
    if (codBtn.disabled) return;
    openCOD(codBtn);
  });

  /* ---------- Agregar al carrito con AJAX ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || theme.cod || theme.cartType !== 'drawer' || !drawer()) return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-button]');
    var msg = form.querySelector('[data-form-error]');
    if (btn) btn.classList.add('is-loading');
    if (msg) msg.textContent = '';

    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);

    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || theme.strings.error);
        if (res.body.sections) renderDrawer(res.body.sections['cart-drawer']);
        openDrawer();
      })
      .catch(function (err) { if (msg) msg.textContent = err.message || theme.strings.error; })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });
})();
